/**
 * Small Mobile <478px
 * Mobile: >=478 & <768px
 * Tablet: >=768 & <1024px
 * Desktop: >=1024px & <1440px
 * Large Desktop: >=1440px & <1920
 * XLarge Desktop: >=1920
 */
var breakpoints = {
  smallMobile: '478px',
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
  largeDesktop: '1920px'
};
var breakpointsArray = [breakpoints.smallMobile, breakpoints.mobile, breakpoints.tablet, breakpoints.desktop, breakpoints.largeDesktop];

export { breakpoints, breakpointsArray };
//# sourceMappingURL=breakpoints.js.map
